import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

priceStyles.productPrice = {
    price: {
        priceText: { size: 32, fontFamily: "LibreBaskervilleBold" },
        unitOfMeasureText: { size: 26, fontFamily: "LibreBaskervilleBold" },
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            color: ${getColor("primary")};
            font-size: 1rem;
            font-family: "LibreBaskerville";
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 50%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};
